import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=39329ce3&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DropdownMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DropdownMenu.vue
// module id = 895
// module chunks = 1